import { render, staticRenderFns } from "./complete.vue?vue&type=template&id=4053142b&scoped=true"
import script from "./complete.vue?vue&type=script&lang=js"
export * from "./complete.vue?vue&type=script&lang=js"
import style0 from "./complete.vue?vue&type=style&index=0&id=4053142b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4053142b",
  null
  
)

export default component.exports